export const DOCUMENT_TYPE_ABOUT_FRONTPAGE = 'about-frontpage';
